import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BTUCalculator from "./components/BTUCalculator";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BTUCalculator />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
